import { v4 as uuid } from 'uuid';
import { type SectionType } from '../../../../../sections/SectionTypeContext.tsx';
import { WidgetSelectFilters } from '../../../../select/WidgetSelectFilters.tsx';
import { type WidgetType } from '../../../../Widget.ts';
import { WidgetDefaultRequiredLogic } from '../../../WidgetDefaultRequiredLogic.ts';
import { WidgetRepository } from '../../../WidgetRepository.ts';
import { type ITableColumnWidget } from '../ITableInputWidget.ts';

/**
 * Crea una colonna di tipo TableColumnType a partire da un widgetType
 * per poter inizializzare i valori quando viene aggiunta alla tabella.
 */
export function createTableWidgetInitialColumn(
  widgetType: WidgetType,
  values: { label: string; code: string },
  // Obbligatori: un default silenzioso disattiverebbe l'obbligatorietà di
  // default (o ne ignorerebbe il toggle del Popover "Creazione nuovi
  // Elementi") nei punti di chiamata che dimenticano i parametri.
  sectionType: SectionType,
  defaultRequired: boolean,
): ITableColumnWidget | null {
  const { label, code } = values;
  const widget = WidgetRepository.find(widgetType);

  if (!widget) {
    // biome-ignore format: <tbd>
    console.error(`[CreateColumnType] Nessun widget con tipo: "${widgetType}"`);
    return null;
  }

  if (!WidgetSelectFilters.TableColumn(widget)) {
    // biome-ignore format: <tbd>
    console.error(`[CreateColumnType] Il widget con tipo: "${widgetType}" non è compatibile con TableColumn`);
    return null;
  }

  const baseWidget: ITableColumnWidget = {
    id: uuid(),
    type: widgetType as any,
    code,
    label: [{ type: 'text', text: label }],
    // Impostato isTableColumn a true di default, sappiamo che il widget é interno ad una tabella
    layout: { isTableColumn: true },
    // Eventuale obbligatorietà di default per gli input delle sezioni
    // frontoffice e backoffice
    ...WidgetDefaultRequiredLogic.getInitialWidgetPartial(
      widgetType,
      sectionType,
      defaultRequired,
    ),
  };

  const result =
    (widget.configValidator?.cast(baseWidget, {
      assert: false,
    }) as ITableColumnWidget | undefined) ?? baseWidget;

  return result;
}
